import React from 'react';
import '../index.css';
import {Button} from "@nextui-org/react";

const Header = () => {
    return (
        <>
            <header>
                <img src="http://www.jsmailing.com.ar/imagenes/simuladorayudas/static/media/logo.b0bc027c0b6842c727c74471aea94216.svg" className="logo" alt="logo"/>
                <nav>
                    <a href="http://www.jerarquicos.com/seccion_63_ayudas-economicas.html" target="_blank">
                        <Button className={"btnHeader"}>
                            Más info
                        </Button>
                    </a>
                    <a href="https://wa.me/+5493425141873" target="_blank">
                        <Button className={"btnHeader"}>
                            Contacto
                        </Button>
                    </a>
                </nav>
            </header>
        </>
    )
};

export default Header;